// Centralized autofill options for the app.

export const PRODUCTS = [
  { value: "Novepoxy", label: "Novepoxy" },
  { value: "Pool Epoxy", label: "Pool Epoxy" },
  { value: "Weatherite", label: "Weatherite" },
  { value: "Living Shield Max", label: "Living Shield Max" },
  { value: "Ultranamel", label: "Ultranamel" },
];

export const BASES = [
  { value: "W", label: "White (W)" },
  { value: "D", label: "Deep (D)" },
  { value: "C", label: "Clear (C)" },
  { value: "B", label: "Mid (B)" },
];

export const SIZES_L = [
  { value: 4, label: "4L Novepoxy" },
  { value: 5, label: "5L Pool Epoxy" },
  { value: 10, label: "10 L" },
  { value: 15, label: "15 L" },
  { value: 20, label: "20 L" },

];

export const COLOR_CHARTS = [
  { value: "Resene Whites and Neuterals", label: "Resene Whites and Neuterals" },
];
